import React from 'react';

import { PER_PAGE, SALES_CHANNELS } from '../../constants';
import FocusLayout from '../../components/FocusLayout';
import DisplayCatalog from './DisplayCatalog';
import { getProducts } from '../../actions/shop';
import DEFAULT_FILTERS from './defaultFilters';

async function action({ store }) {
  const {
    shop: { currentPage = 1 },
    config: { salesChannel },
  } = store.getState();

  await store.dispatch(
    getProducts({
      page: 1,
      perPage: currentPage * PER_PAGE,
      id: salesChannel?.id || SALES_CHANNELS.REDEEM,
      params: DEFAULT_FILTERS,
      includePriceIntervalInput: false,
    }),
  );

  const { logoUrl, colorScheme } = salesChannel || {};

  return {
    title: 'Display Redeem Catalog',
    chunks: ['display-catalog'],
    salesChannelId: salesChannel?.id || SALES_CHANNELS.REDEEM,
    component: (
      <FocusLayout focusContentBox={false} lightTheme color={colorScheme}>
        <DisplayCatalog logo={logoUrl || ''} />
      </FocusLayout>
    ),
    meta: [{ name: 'robots', content: 'noindex' }],
  };
}

export default action;
